import { render, staticRenderFns } from "./MealInfo.vue?vue&type=template&id=148d1769&scoped=true&"
import script from "./MealInfo.vue?vue&type=script&lang=js&"
export * from "./MealInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d1769",
  null
  
)

export default component.exports